import React from "react";
import dayjs from "dayjs";
import duration from "dayjs/plugin/duration";
import { formatTimeDifference } from "../../utils/utils";
import { useGlobalTimer } from '../../providers/GlobalTimerProvider';

dayjs.extend(duration);

interface RealtimeHoursOpenProps {
  readonly outOfServiceDateTimeUTC: string;
  readonly returnToServiceDateTimeUTC?: string;
  readonly className?: string;
}

export const getHoursOpen = (
  outOfServiceDate: string,
  returnToServiceDate?: string,
  currentDate = dayjs()
) => {
  const servicedDate = dayjs(outOfServiceDate);
  if (returnToServiceDate) {
    currentDate = dayjs(returnToServiceDate);
  }
  let diff = currentDate.diff(servicedDate);
  const duration = dayjs.duration(diff);
 
  return {duration, diff};
};

export default function RealtimeHoursOpen({ 
  outOfServiceDateTimeUTC, 
  returnToServiceDateTimeUTC,
  className = "data-field hours-minutes"
}: RealtimeHoursOpenProps) {
  const currentTime = useGlobalTimer();

  const { diff } = getHoursOpen(
    outOfServiceDateTimeUTC,
    returnToServiceDateTimeUTC,
    dayjs(currentTime)
  );

  const formattedHoursOpen = formatTimeDifference(diff);
  
  return <span className={className}>{formattedHoursOpen}</span>;
}
